import { View } from "binder"
import { FormBuilderElement } from "../../element";
import { ComponentDropDecoratorViewModel } from "./componentDropDecorator-viewModel";

export class CompactView extends View<ComponentDropDecoratorViewModel>{
    GetViewUniqueId(): string {
        return "V-DFB7AC79-744D-46B8-806A-B4557212426E"
    }
    loadHtml(): string {
        let element = require('./compact.html').default;
        let style = require('./compact.less');
        return element;
    }
    constructor() {
       super();
    }
    public set decoratorComponent(v: FormBuilderElement) { this._decoratorComponent = v; } public get decoratorComponent(): FormBuilderElement { return this._decoratorComponent;} private _decoratorComponent: FormBuilderElement;

}
